import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import Inspector from "./Inspector.js";
import UpdateInspector from "./UpdateInspector";
import ViewInspector from "./ViewInspector";

class AdminInspectorRoutes extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/inspector" component={Inspector} />
        <Route exact path="/inspector/edit/:iId" component={UpdateInspector} />
        <Route exact path="/inspector/view/:iId" component={ViewInspector} />
      </Switch>
    );
  }
}

export default AdminInspectorRoutes;



// WEBPACK FOOTER //
// ./src/admin/AdminInspectorRoutes.js